import type { ResponsiveImageData } from './images'
import { images } from './images'

export type Transformation = {
  number: string
  title: string
  service: string
  description: string
  beforeImage?: ResponsiveImageData
  afterImage?: ResponsiveImageData
  beforeAlt: string
  afterAlt: string
  beforePosition?: string
  afterPosition?: string
}

export const transformations: Transformation[] = [
  {
    number: '01',
    title: 'Dimensional color',
    service: 'Color correction',
    description: 'A tailored color story shaped around tone, depth, and the way you wear your hair.',
    beforeImage: images.colorCorrectionBefore,
    afterImage: images.ColorCorrectionAfter,
    beforeAlt: 'Before color correction showing long, deep red-brown hair',
    afterAlt: 'After color correction showing long brunette hair with dimensional highlights and waves',
  },
  {
    number: '02',
    title: 'The new shape',
    service: 'Cut & style',
    description: 'Precision, movement, and a silhouette designed to work well beyond the salon chair.',
    beforeImage: images.cutAndStyleBefore,
    afterImage: images.cutAndStyleAfter,
    beforeAlt: 'Before cut and style showing long, straight brunette hair',
    afterAlt: 'After cut and style showing a shoulder-length brunette cut with soft waves',
  },
  {
    number: '03',
    title: 'Luminous blonde',
    service: 'Blonding',
    description: 'Considered brightness with dimension, softness, and healthy-looking shine.',
    beforeImage: images.beforeBlonding,
    afterImage: images.afterBlonding,
    beforeAlt: 'Before blonding showing long, warm brown hair',
    afterAlt: 'After blonding showing long, dimensional blonde hair styled in loose waves',
  },
]
